export const FETCH_DOCUMENT = 'FETCH_DOCUMENT';
export const FETCH_DOCUMENT_COMPLETE = 'FETCH_DOCUMENT_COMPLETE';
